import script from "./evaluateLog.vue?vue&type=script&setup=true&lang=js"
export * from "./evaluateLog.vue?vue&type=script&setup=true&lang=js"

import "./evaluateLog.vue?vue&type=style&index=0&id=dfd6d35c&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd6d35c"]])

export default __exports__